import { enTranslations } from './locales/en'
import { zhTranslations } from './locales/zh'

export type Language = 'en' | 'zh'

export const LANGUAGE_STORAGE_KEY = 'app_language'
export const DEFAULT_LANGUAGE: Language = 'en'

/** Fallback chain: after the requested language, try English (canonical), then Chinese. */
export const FALLBACK_CHAIN: Language[] = ['en', 'zh']

export const LANGUAGE_OPTIONS: { value: Language; label: string }[] = [
  { value: 'en', label: 'English' },
  { value: 'zh', label: '中文' },
]

export const translations: Record<Language, Record<string, string>> = {
  en: enTranslations,
  zh: zhTranslations,
}

export function getLocalizedField(obj: unknown, field: string, language: Language): string {
  if (typeof obj !== 'object' || obj === null) {
    return ''
  }

  const record = obj as Record<string, unknown>

  if (language !== 'en') {
    const value = record[`${field}_${language}`]
    if (typeof value === 'string') {
      return value
    }
  }
  
  const value = record[field]
  if (typeof value === 'string') {
    return value
  }
  
  return ''
}

export function getDocUrl(path: string, language: Language = 'en'): string {
  const baseUrl = process.env.NEXT_PUBLIC_DOC_URL || 'https://fishmall-doc.fkxiaoyu.com/agent'
  const langPrefix = language === 'en' ? '' : `/${language}`
  
  // Clean the path: remove .md or .mdx extensions and ensure it starts with /
  let cleanPath = path.replace(/\.mdx?$/, '')
  cleanPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`
  
  return `${baseUrl}${langPrefix}${cleanPath}`
}
